module.exports = __webpack_public_path__ + "static/media/icon_info.b975d22d.svg";